import usePlan from 'hooks/plan/usePlan';
import React, { useEffect, useMemo } from 'react';
import FulfilledByMonthCard from './FulfilledByMonthCard';

interface FulfilledByMonthLegacyProps {
    loading: boolean;
    hasSubscription: boolean;
}

const FulfilledByMonthLegacy: React.FC<FulfilledByMonthLegacyProps> = ({ loading: loadingData, hasSubscription }) => {
    const { getMonthlyOrderLimit, isUnlimitedOrderLimit, refresh: refreshPlanLimits, loading } = usePlan();

    useEffect(() => {
        refreshPlanLimits();
    }, []);

    const currentlyUsed = useMemo(() => getMonthlyOrderLimit()?.currentlyUsed, [getMonthlyOrderLimit]);
    const limit = useMemo(() => getMonthlyOrderLimit()?.value, [getMonthlyOrderLimit]);
    const isUnlimited = useMemo(() => isUnlimitedOrderLimit(), [isUnlimitedOrderLimit]);

    return (
        <FulfilledByMonthCard
            isUnlimited={isUnlimited}
            loading={loading}
            loadingData={loadingData}
            hasSubscription={hasSubscription}
            currentlyUsed={currentlyUsed}
            limit={limit}
        />
    );
};

export default FulfilledByMonthLegacy;
